import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import CardIcon from '../CardIcon/CardIcon.js';
import { useTranslation } from '../../hooks/useTranslations.js';
import { cardTypeOfCreditCardBrand } from '../../types-internal/index.js';
import styles from './DetectedCardBrandsController.module.scss.js';

/**
 * The component to render and control the detected brands of a card. In case the card is one-branded card, this
 * controller will present that brand icon. If the card is co-branded, we will render a list of clickable icon, and
 * the user can select their preferred brand by clicking on the brand icon
 */
const DetectedCardBrandsController = ({ detectedCardBrands = [], onBrandSelected, selectedBrand, coBrandedMessageClassName, }) => {
    const { t } = useTranslation();
    /* The logic of card brand detection from Adyen SDK:
     * (1) If the input is empty, or the user input a nonsense card number, both "selectedBrand" and
     *     "detectedCardBrands" are empty. In this case, this controller component should be empty.
     * (2) If the user input the 1st, or first 2 digits, Adyen SDK will start detect the card brand, for instance,
     *     Visa card starts with number 4, Maestro card starts with number 6. At this point, the "selectedBrand"
     *     has value, but the "detectedCardBrands" will still be empty. The "detectedCardBrands" will have value
     *     only when the user complete the BIN (first 6 to 8 card digits).
     * (3) If the users complete input the BIN, both "selectedBrand" and "detectedCardBrands" are set. By default,
     *     the value of "selectedBrand" will still be the detected value from point (2), until the user select their
     *     preferred brand. */
    /* If "detectedCardBrands" has more than 1 item, it means the card is co-badged, so we return the
     * list of clickable icons. */
    if (detectedCardBrands.length > 1) {
        return (jsxs("div", { className: styles.container, children: [jsx("span", { className: classNames(styles.coBrandedMessage, coBrandedMessageClassName), children: t('checkout.form.cobranded.message') }), jsx("span", { className: styles.cardListContainer, children: detectedCardBrands.map((brand) => {
                        return (brand && (jsx(CardIcon, { className: classNames(styles.card, brand === selectedBrand && styles.selected), subtle: brand !== selectedBrand, clickable: true, onClick: () => onBrandSelected?.(brand), type: cardTypeOfCreditCardBrand[brand] }, brand)));
                    }) })] }));
    }
    /* If the "detectedCardBrands" has only 1 item or empty, we are safe to rely only on the "selectedBrand"
     * attribute to render the card icon. */
    if (selectedBrand) {
        return (jsx("div", { className: styles.container, children: jsx(CardIcon, { type: cardTypeOfCreditCardBrand[selectedBrand], className: styles.card }) }));
    }
    // If no brand selected, the controller should be empty
    return null;
};

export { DetectedCardBrandsController as default };
//# sourceMappingURL=DetectedCardBrandsController.js.map
